import {
  ArrowsLeftRightIcon,
  ArrowUDownLeftIcon,
  HouseLineIcon,
  MapPinIcon,
  PersonIcon,
  ShuffleIcon,
  StorefrontIcon,
} from '@phosphor-icons/react'

export const locationListTypeValues = {
  url: 'url',
  locations: 'store_locations',
}

export const errorTypes = {
  allowedEmpty: 'allowedEmpty',
  regionsEmpty: 'regionsEmpty',
  extraFeeEmpty: 'extraFeeEmpty',
  carrierEmpty: 'carrierEmpty',
  countryEmpty: 'countryEmpty',
  provinceEmpty: 'provinceEmpty',
  customNamesEmpty: 'customNamesEmpty',
  locationIdEmpty: 'locationIdEmpty',
  internalNameEmpty: 'internalNameEmpty',
  invalidRegionForCarrierService: 'invalidRegionForCarrierService',
  invalidLocationForCarrierService: 'invalidLocationForCarrierService',
  invalidIncludedItems: 'invalidIncludedItems',
  invalidIncludedItemsAdditionalTransaction: 'invalidIncludedItemsAdditionalTransaction',
}

export const returnMethods = {
  customerdelivers: 'customerdelivers',
  pickuppoint: 'pickuppoint',
  customerpickup: 'customerpickup',
  returntostore: 'returntostore',
}

export const returnMethodsWithCarrierSetup = [returnMethods.customerpickup, returnMethods.pickuppoint]

export const enabledForValues = {
  refunds: 'enabled_for_refunds',
  exchanges: 'enabled_for_exchanges',
  mixed: 'enabled_for_mixed',
}

export const feeTypes = {
  perReturnedItem: 'per_returned_item',
  flatFee: 'flat_fee',
}

export const carrierServiceTypes = {
  homePickup: 'home_pickup',
  dropoffPoint: 'dropoff_point',
  shipment: 'shipment',
}

export const deliveryMethodTypeCards = [
  {
    value: returnMethods.customerpickup,
    title: 'Recogida en domicilio',
    description: 'Un mensajero recoge el paquete en la dirección del cliente.',
    Icon: HouseLineIcon,
  },
  {
    value: returnMethods.customerdelivers,
    title: 'El cliente lo envía',
    description: 'El cliente organiza y paga el envío con el servicio que elija.',
    Icon: PersonIcon,
  },
  {
    value: returnMethods.pickuppoint,
    title: 'Punto de entrega',
    description: 'El cliente lleva el paquete a un punto de recogida cercano de tu red logística.',
    Icon: MapPinIcon,
  },
  {
    value: returnMethods.returntostore,
    title: 'Devolver en tienda',
    description: 'El cliente devuelve el producto en una de tus tiendas físicas.',
    Icon: StorefrontIcon,
  },
]

export const enabledForCards = [
  {
    value: enabledForValues.refunds,
    title: 'Devoluciones',
    description: 'El cliente quiere devolver productos',
    Icon: ArrowUDownLeftIcon,
  },
  {
    value: enabledForValues.exchanges,
    title: 'Cambios',
    description: 'El cliente quiere cambiar productos por otros',
    Icon: ArrowsLeftRightIcon,
  },
  {
    value: enabledForValues.mixed,
    title: 'Mixto',
    description: 'El cliente quiere devolver algunos productos y cambiar otros',
    Icon: ShuffleIcon,
    requiresUnifiedFlow: true,
  },
]
